import { DESIGN_TOKEN } from "Config/design_token";
import { TABLET_LAYOUT, DESKTOP_LAYOUT } from "./constants";

const block = `.wp-block-sandpiper-profile`;

/** Styles for the wp-block-sandpiper-profile block. */
export const PROFILE_STYLES = `
  ${block} {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-bottom: 4rem;
  }
  ${TABLET_LAYOUT} ${block},
  ${DESKTOP_LAYOUT} ${block} {
    flex-direction: row;
  }

  ${block}__portrait {
    display: flex;
    width: 100%; 
    height: auto;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
  }
  ${TABLET_LAYOUT} ${block}__portrait,
  ${DESKTOP_LAYOUT} ${block}__portrait {
    display: inline-flex;
    width: 15rem;
    margin-right: 2rem;
    margin-bottom: 0rem;
    flex-shrink: 0;
    flex-grow: 0;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  ${block}__portrait__img {
    width: 100%;
    max-width: 20rem;
    height: auto;
    flex-grow: 0;
    padding: 1rem;
    border: thin solid ${DESIGN_TOKEN.colors.swatch_5};
  }
  ${TABLET_LAYOUT} ${block}__portrait__img,
  ${DESKTOP_LAYOUT} ${block}__portrait__img {
    padding: 0rem;
    border: none;
  }

  ${block}__bio {
    display: inline-flex;
    width: 100%;
    flex-shrink: 1;
    flex-grow: 0;
    flex-direction: column;
  }
  ${TABLET_LAYOUT} ${block}__bio,
  ${DESKTOP_LAYOUT} ${block}__bio {
    width: calc(100% - 17rem);
  }

  ${block}__bio__title {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  ${block}__bio__text {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  ${block}__bio__text p:last-of-type {
    margin-bottom: 0rem;
  }
`;
